const routes = [
  {
    path: 'full-bleed',
    name: 'full-bleed',
    component: () => import(/* webpackChunkName: "full-bleed" */ '@/modules/full-bleed/index.vue')
  },
];

export default routes;